/*==================== ACCORDION BLOCKS ====================*/
document.addEventListener('DOMContentLoaded', function() {
    const accordionBlocks = document.querySelectorAll('.wp-block-gfd-accordions-block');

    accordionBlocks.forEach(block => {
        const items = block.querySelectorAll('.item');

        items.forEach(item => {
            item.querySelector('.item-title').addEventListener('click', function() {
                const isActive = item.classList.contains('active');
                items.forEach(i => i.classList.remove('active'));
                if (!isActive) {
                    item.classList.add('active');
                }
            });
        });
    });
});